var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusReport = function SvgPlusReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66659 1.00016C7.66659 0.631973 7.36811 0.333496 6.99992 0.333496C6.63173 0.333496 6.33325 0.631973 6.33325 1.00016V6.3335H0.999919C0.631729 6.3335 0.333252 6.63197 0.333252 7.00016C0.333252 7.36835 0.631729 7.66683 0.999919 7.66683H6.33325V13.0002C6.33325 13.3684 6.63173 13.6668 6.99992 13.6668C7.36811 13.6668 7.66659 13.3684 7.66659 13.0002V7.66683H12.9999C13.3681 7.66683 13.6666 7.36835 13.6666 7.00016C13.6666 6.63197 13.3681 6.3335 12.9999 6.3335H7.66659V1.00016Z",
    fill: "#253858"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-report.d025f1f4.svg";
export { ForwardRef as ReactComponent };